import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { join } from 'ramda';

import { hasValue } from '../../util';
import { FileUploadAttribute, InputType } from '../models';
import { BaseFileUploadDirective } from './base-file-upload.directive';

@Directive({
  selector: '[pcsFileSelect]'
})
export class FileSelectDirective extends BaseFileUploadDirective implements OnChanges {
  @Output() fileSelected = new EventEmitter<File>();

  private get input() {
    return this.hostElementRef.nativeElement;
  }

  private get inputType() {
    return this.input.type;
  }

  private get files() {
    return this.input.files;
  }

  constructor(private hostElementRef: ElementRef<HTMLInputElement>, private renderer: Renderer2) {
    super();
    if (this.inputType !== InputType.File) {
      throw new Error('pcsFileSelect must be used on input with type "file"!');
    }
  }

  ngOnChanges({disabled, accepts, fileSize}: SimpleChanges): void {
    if (disabled && disabled.previousValue !== disabled.currentValue) {
      this.handleDisabled();
    }
    if (accepts && accepts.previousValue !== accepts.currentValue) {
      this.handleAccepts();
    }
    if (fileSize && fileSize.previousValue !== fileSize.currentValue) {
      this.handleFileSize();
    }
  }

  @HostListener('change')
  onChange() {
    if (this.fileAllowed(this.files)) {
      this.fileSelected.emit(this.selectedFile(this.files));
      this.input.value = null;
    }
  }

  private handleDisabled() {
    if (this.disabled) {
      this.renderer.setAttribute(this.input, FileUploadAttribute.Disabled, String(this.disabled));
    } else {
      this.renderer.removeAttribute(this.input, FileUploadAttribute.Disabled);
    }
  }

  private handleAccepts() {
    if (hasValue(this.accepts)) {
      this.renderer.setAttribute(this.input, FileUploadAttribute.Accept, join(', ', this.accepts));
    } else {
      this.renderer.removeAttribute(this.input, FileUploadAttribute.Accept);
    }
  }

  private handleFileSize() {
    if (hasValue(this.fileSize)) {
      this.renderer.setAttribute(this.input, FileUploadAttribute.Size, String(this.fileSize));
    } else {
      this.renderer.removeAttribute(this.input, FileUploadAttribute.Size);
    }
  }

}
